import { useMemo } from 'react'
import { Drawer, Box } from '@mui/material';
import { DataGridPremium, GridColDef, GridRenderCellParams, useGridApiRef } from '@mui/x-data-grid-premium';
import StyledBox from '../../common/Components/StyledBox'
import BoxHeader from '../../common/Components/BoxHeader'
import { useFetch, Status } from '../../hooks/useFetch';
import { Message, MessageRecipient } from '@aviation/cabinapp-message-service-sdk';
import dayjs from 'dayjs';


export interface IDelayCommDetails {
    open: boolean;
    item : Message;
    cancelAction: () => void;
}

function DelayCommDetails(props: IDelayCommDetails) {
    const apiRef = useGridApiRef();
    const { status, data = [] } = useFetch<Message>(`/api/message/${props.item.Id ?? ''}/details`);
    
    
    const columns: GridColDef[] = [
        { field: 'LtrCode', headerName: '3LC', minWidth: 80 },
        { field: 'ClientCode', headerName: 'Source Market', minWidth: 120 },
        { field: 'Method', headerName: 'Delivery method', minWidth: 150 },
        { field: 'DeliveredOn', headerName: 'Delivered on', minWidth: 150, renderCell: (params: GridRenderCellParams<Date>) => params.value === undefined ? '' : dayjs(params.value).format('DD.MM.YYYY HH:mm') },
    ];

    const rowId = (row : MessageRecipient) => {
        return row.Id;
    }
    const rows = useMemo(() => {
        let msg = data as Message;
        let recipients =  msg?.Recipients ?? []; //data?.Recipients; // data?.flatMap(o => o.Recipients ?? []) ?? [];
        return recipients.map(o => {
            let delivery = o.Delivery?.find(d => d.DeliveredOn !== undefined);

            return {
                ...o,
                id: rowId(o),
                Method: delivery?.DeliveryMethod ?? 'Not delivered',
                DeliveredOn: delivery?.DeliveredOn
            }
        })
    }, [data]);

    return (
        <Drawer anchor='right' open={props.open} onClose={(e, r) => { props.cancelAction(); }} style={{ maxWidth: '50%' }}>
            <Box style={{ marginTop: 70, paddingLeft: 20, paddingRight: 20 }}>
                <BoxHeader title={'Recipients'}>
                    
                </BoxHeader>
            </Box>
            <StyledBox style={{ paddingLeft: 20, paddingRight: 20 }}>
                <DataGridPremium
                    apiRef={apiRef}
                    autoHeight
                    rows={rows}
                    columns={columns}
                    loading={status === Status.Fetching}
                    editMode="row"
                    getRowClassName={(params) => { return params.indexRelativeToCurrentPage % 2 === 0 ? `tui-grid-alternate-row` : '' }}
                    // pagination
                    isCellEditable={(params) => false}
                />
            </StyledBox>
            
        </Drawer>
    )
}

export default DelayCommDetails